jQuery(document).ready(function ($) {

    // -------------------------------------------------------------------------
    // 2026 reskin — carousel navigation.
    //
    // The designs replaced the arrows either side of the imagery with a row of
    // dots underneath. Arrows are wanted back for anyone who does not read a dot
    // as a control, and they sit where arrows normally do: one at each side of
    // the panels, vertically centred on them. The dots stay underneath.
    //
    // The two go into separate containers, because they are positioned against
    // different things — the arrows against the panels, the dots against the
    // foot of the carousel. slick takes a container for each set, so both are
    // built here and handed over through appendArrows / appendDots.
    //
    // Use this in place of .slick() for any carousel that shows dots. It is
    // per-element on purpose: a block can appear more than once on a page, and
    // one shared options object would have sent every instance's controls into
    // the first instance's containers.
    // -------------------------------------------------------------------------
    function woodpeckerCarousel(selector, options) {
        $(selector).each(function () {
            var $carousel = $(this);

            // Held out of the document until slick has initialised. Everything
            // that is a child of the carousel when .slick() runs is taken for a
            // slide, so neither container can be in place beforehand.
            var $arrows = $('<div class="carousel-arrows"></div>');
            var $dots = $('<div class="carousel-nav"></div>');

            // Bound before .slick() so the first 'init' is caught.
            //
            // With every slide already on screen there is nothing to page
            // through: slick builds no arrows, and the dots it does build come
            // to a single dot that has never done anything. Both go. This is
            // the common case on Similar Floors — a range of five floors shown
            // 5.35 across — and on "Floors in the wild", which is four across
            // and frequently holds exactly four photographs.
            $carousel.on('init reInit setPosition', function (event, slick) {
                var idle = slick
                    ? slick.slideCount <= slick.options.slidesToShow
                    : $dots.children().length === 0;

                $arrows.toggleClass('carousel-arrows--idle', idle);
                $dots.toggleClass('carousel-nav--idle', idle);
            });

            $carousel.slick($.extend({}, options, {
                arrows: true,
                dots: true,
                appendArrows: $arrows,
                appendDots: $dots,
                // Crossing a responsive breakpoint sends slick through
                // destroy() and straight back into init(), and init() takes
                // every child of the carousel for a slide. Both containers are
                // children by then, so they have to be excluded by name or they
                // become blank slides the first time the window is resized past
                // a breakpoint. `slide` is slick's own hook for this.
                slide: (options.slide || '*') + ':not(.carousel-arrows):not(.carousel-nav)',
                prevArrow: '<button type="button" class="carousel-arrow carousel-arrow--prev" aria-label="Previous"></button>',
                nextArrow: '<button type="button" class="carousel-arrow carousel-arrow--next" aria-label="Next"></button>'
            }));

            // Dropped in after init, into .slick-slider itself — which is where
            // slick would have put its own controls, and which is the positioned
            // box both are measured from. Putting them here rather than after
            // the carousel is what lets the existing per-carousel dot offsets
            // carry over untouched.
            $carousel.append($arrows).append($dots);
        });
    }

    if ($(window).width() < 992) {
        // 2026 reskin: dots underneath, and the track runs off the right of the
        // screen so a partial tile is always showing.
        woodpeckerCarousel('.popular-floors .tile-container', {
            slidesToShow: 2,
            // Page a screenful at a time so the dot count stays readable.
            slidesToScroll: 2,
            infinite: false,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.3,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        woodpeckerCarousel('.as-seen-in .gallery', {
            centerMode: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 2
                    }
                }
            ]
        });


        $('.in-the-showroom .range-container').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        slidesToShow: 1
                    }
                }
            ]
        })

    } else {
        woodpeckerCarousel('.popular-floors .tile-container', {
            // Full width track, so more tiles fit across. The fractional count is
            // what pushes the track past the right edge.
            slidesToShow: 5.35,
            // Page a screenful at a time so the dot count stays readable.
            slidesToScroll: 5,
            infinite: false
        });

        console.log($('.in-the-showroom .range-container').children().length);

        if ($('.in-the-showroom .range-container').children().length >= 4) {
            $('.in-the-showroom .range-container').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                autoplay: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: true,
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: true,
                            slidesToShow: 1
                        }
                    }
                ]
            })
        }
    }

    if($(window).width() < 500){
        $('.single-retailer .gallery.square .gallery-inner').slick({
            slidesToShow: 1,
            slidesToScroll: 1
        })
    } else if($(window).width() < 768 && $('.single-retailer .gallery-item').length > 1){
        $('.single-retailer .gallery.square .gallery-inner').slick({
            slidesToShow: 2,
            slidesToScroll: 2
        })
    } else if($(window).width() < 992 && $('.single-retailer .gallery-item').length > 2) {
        $('.single-retailer .gallery.square .gallery-inner').slick({
            slidesToShow: 3,
            slidesToScroll: 3
        })
    } else if($('.single-retailer .gallery-item').length > 3) {
        $('.single-retailer .gallery.square .gallery-inner').slick({
            slidesToShow: 4,
            slidesToScroll: 4
        })
    }

    $('.promo-boxes').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            },
        ]
    })

    woodpeckerCarousel('.inspiration-carousel-inner', {
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    })


    $('.faqs .faq-title').on('click', function () {
        $('.faq-body').not($(this).siblings('.faq-body')).slideUp();
        $(this).siblings('.faq-body').slideToggle();
    })

    $('.woocommerce-cart .cross-sells .cross-sell-carousel').slick({
        slide: 'li',
        slidesToShow: 4,
        dots: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    })

    $('.useful-articles-inner').slick({
        slidesToShow: 3,
        dots: false,
        arrows: true,
        // 2026 reskin: not infinite, so slick disables the arrows when there is
        // nothing either side. Most ranges carry exactly three articles and the
        // design has no arrows on that — the disabled state is hidden in CSS.
        infinite: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.image-gallery-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1
    })

    // 2026 reskin: "Floors in the wild" at the foot of a collection page. Four
    // across with dots and no arrows, paging a screenful at a time.
    woodpeckerCarousel('.collection-gallery__carousel', {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    })

    // -------------------------------------------------------------------------
    // 2026 reskin: collection filter bar.
    //
    // Each heading opens a panel of checkboxes. On a collection page ticking one
    // refreshes the grid over AJAX rather than reloading, and the URL is kept in
    // step so the filtered view can be shared or reloaded —
    // inc/collectionFilters.php reads the same query string in pre_get_posts,
    // which is also what makes the bar work as a plain form with JavaScript off.
    //
    // The product category, tag and key feature archives carry the same bar but
    // still page their grid, so there it stays a plain form: the panels open and
    // the tallies update here, and Apply submits. `ajax` in the localised object
    // says which of the two this page is.
    // -------------------------------------------------------------------------
    var $filterBar = $('.collection-filters');

    if ($filterBar.length && typeof woodpeckerCollectionFilters !== 'undefined') {
        var filterByAjax = String(woodpeckerCollectionFilters.ajax) === '1';
        var $grid = $filterBar.closest('.site-main').find('ul.products').first();
        var filterRequest = null;

        // The container the "nothing matched" message goes in, created once. Only
        // the AJAX bar needs it — where the form submits, an empty result is Woo's
        // own "no products were found" page.
        var $empty = $('<p class="collection-filters__empty" hidden>No floors in this collection match those filters.</p>');

        if (filterByAjax) {
            $grid.after($empty);
        }

        function closeFilterPanels($except) {
            $filterBar.find('.collection-filters__group').each(function () {
                if ($except && this === $except[0]) {
                    return;
                }
                $(this).removeClass('is-open')
                    .find('.collection-filters__toggle').attr('aria-expanded', 'false')
                    .end()
                    .find('.collection-filters__options').prop('hidden', true);
            });
        }

        // Selections as { taxonomy: [slug, ...] }, only for the ones with a tick.
        function currentFilters() {
            var filters = {};

            $filterBar.find('.collection-filters__group').each(function () {
                var taxonomy = $(this).data('taxonomy');
                var slugs = $(this).find('input:checked').map(function () {
                    return this.value;
                }).get();

                if (slugs.length) {
                    filters[taxonomy] = slugs;
                }
            });

            return filters;
        }

        function updateFilterChrome(filters) {
            var total = 0;

            $filterBar.find('.collection-filters__group').each(function () {
                var $group = $(this);
                var slugs = filters[$group.data('taxonomy')] || [];
                var $count = $group.find('.collection-filters__count');

                total += slugs.length;
                $group.toggleClass('is-active', slugs.length > 0);

                if (!slugs.length) {
                    $count.remove();
                } else if ($count.length) {
                    $count.text(slugs.length);
                } else {
                    $group.find('.collection-filters__toggle')
                        .append($('<span class="collection-filters__count"></span>').text(slugs.length));
                }
            });

            $filterBar.find('.collection-filters__clear')
                .prop('hidden', total === 0)
                .text(total ? 'Clear (' + total + ')' : 'Clear');
        }

        function pushFilterState(filters) {
            if (!window.history || !window.history.replaceState) {
                return;
            }

            var parts = [];
            Object.keys(filters).forEach(function (taxonomy) {
                parts.push(encodeURIComponent(taxonomy) + '=' + filters[taxonomy].map(encodeURIComponent).join(','));
            });

            window.history.replaceState({}, '', location.pathname + (parts.length ? '?' + parts.join('&') : ''));
        }

        function applyFilters() {
            var filters = currentFilters();

            updateFilterChrome(filters);

            // A paging archive has no AJAX grid to swap: the tallies are updated
            // and the shopper presses Apply, which submits the form and lets
            // pre_get_posts do the filtering. Rewriting the URL here would make
            // the address bar disagree with what is on screen.
            if (!filterByAjax) {
                return;
            }

            pushFilterState(filters);

            if (filterRequest) {
                filterRequest.abort();
            }

            $grid.addClass('is-loading');

            filterRequest = $.post(woodpeckerCollectionFilters.ajaxUrl, {
                action: 'woodpecker_filter_collection',
                nonce: woodpeckerCollectionFilters.nonce,
                term: woodpeckerCollectionFilters.term,
                filters: filters
            }).done(function (response) {
                if (!response || !response.success) {
                    return;
                }

                $grid.html(response.data.html).prop('hidden', response.data.count === 0);
                $empty.prop('hidden', response.data.count > 0);

                // The lazy-loader only scans on its own events, so anything that
                // has just landed needs pointing at.
                if (typeof window.lazySizes !== 'undefined') {
                    window.lazySizes.autoSizer.checkElems();
                }
            }).always(function () {
                $grid.removeClass('is-loading');
                filterRequest = null;
            });
        }

        $filterBar.on('click', '.collection-filters__toggle', function (event) {
            event.preventDefault();

            var $group = $(this).closest('.collection-filters__group');
            var open = !$group.hasClass('is-open');

            closeFilterPanels($group);
            $group.toggleClass('is-open', open);
            $(this).attr('aria-expanded', open ? 'true' : 'false');
            $group.find('.collection-filters__options').prop('hidden', !open);
        });

        $filterBar.on('change', 'input[type="checkbox"]', applyFilters);

        $filterBar.on('click', '.collection-filters__clear', function (event) {
            event.preventDefault();
            $filterBar.find('input:checked').prop('checked', false);
            closeFilterPanels();

            // Where the grid is not swapped in place, clearing has to go back to
            // the unfiltered archive — unticking the boxes on its own would leave
            // the filtered grid on screen with an empty bar above it. The form's
            // own action is that URL.
            if (!filterByAjax) {
                window.location.href = $filterBar.attr('action');
                return;
            }

            applyFilters();
        });

        // The panels are overlays, so anything outside the bar closes them.
        $(document).on('click', function (event) {
            if (!$(event.target).closest('.collection-filters').length) {
                closeFilterPanels();
            }
        });

        $(document).on('keyup', function (event) {
            if (event.key === 'Escape') {
                closeFilterPanels();
            }
        });
    }

    $('.product-gallery-carousel').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    })

    $('.product-gallery-carousel, .gallery-block').slickLightbox({
        slidesToShow: 4,
        slidesToScroll: 1,
        itemSelector: '.sr-lightbox-trigger',
        caption: 'caption'
    })

    $('.single-retailer .gallery-inner').slickLightbox({
        slidesToShow: 4,
        slidesToScroll: 1,
        itemSelector: '.gallery-item a',
        caption: 'caption'
    })

    $('.contact-retailer-btn').on('click', function () {
        $('body').addClass('oy-hidden');
        $('.contact-form-modal').addClass('active');
        $('.contact-form-modal-bg').addClass('active');
    })

    $('.contact-form-modal .close-icon').on('click', function () {
        $('body').removeClass('oy-hidden');
        $('.contact-form-modal').removeClass('active');
        $('.contact-form-modal-bg').removeClass('active');
    })

    $('.filter-toggle').on('click', function () {
        $('.filter-links').toggleClass('active');
    })

    $('header').css('visibility', 'visible');

    ///////////////////////////
    //Checkout Custom Scripts//
    ///////////////////////////

    function watchAndUpdateSiblingField(element, target) {
        $(element).on('blur', function () {
            updateSiblingField(element, target);
        })
    }

    function updateSiblingField(element, target) {
        if ($('.woocommerce-billing-fields__field-wrapper').hasClass('locked')) {
            $(target).val($(element).val()).change();
        }
    }

    function watchAllSiblingFields() {
        watchAndUpdateSiblingField('#shipping_company', '#billing_company');
        watchAndUpdateSiblingField('#shipping_first_name', '#billing_first_name');
        watchAndUpdateSiblingField('#shipping_last_name', '#billing_last_name');
        watchAndUpdateSiblingField('#shipping_postcode', '#billing_postcode');
        watchAndUpdateSiblingField('#shipping_phone', '#billing_phone');
        watchAndUpdateSiblingField('#shipping_email', '#billing_email');
        watchAndUpdateSiblingField('#shipping_address_1', '#billing_address_1');
        watchAndUpdateSiblingField('#shipping_address_2', '#billing_address_2');
        watchAndUpdateSiblingField('#shipping_address_2', '#billing_address_2');
        watchAndUpdateSiblingField('#shipping_city', '#billing_city');
        watchAndUpdateSiblingField('#shipping_state', '#billing_state');
        watchAndUpdateSiblingField('#shipping_country', '#billing_country');
    }

    function updateAllSiblingFields() {
        updateSiblingField('#shipping_company', '#billing_company');
        updateSiblingField('#shipping_first_name', '#billing_first_name');
        updateSiblingField('#shipping_last_name', '#billing_last_name');
        updateSiblingField('#shipping_postcode', '#billing_postcode');
        updateSiblingField('#shipping_phone', '#billing_phone');
        updateSiblingField('#shipping_email', '#billing_email');
        updateSiblingField('#shipping_address_1', '#billing_address_1');
        updateSiblingField('#shipping_address_2', '#billing_address_2');
        updateSiblingField('#shipping_address_2', '#billing_address_2');
        updateSiblingField('#shipping_city', '#billing_city');
        updateSiblingField('#shipping_state', '#billing_state');
        updateSiblingField('#shipping_country', '#billing_country');
    }

    watchAllSiblingFields();

    $('#editBillingDetails').on('change', function () {
        var wrapper = $('.woocommerce-billing-fields__field-wrapper');
        if ($(this).prop('checked')) {
            wrapper.addClass('locked');
            updateAllSiblingFields();
            console.log('updating');

        } else {
            wrapper.removeClass('locked');
            updateAllSiblingFields();
        }
    })

    $('#account_password_custom').on('blur', function () {
        var val = $(this).val();
        if (val !== '') {
            $('#account_password').val(val)
            $('#createaccount').prop('checked', true)
        } else {
            $('#account_password').val('')
            $('#createaccount').prop('checked', false)
        }
    })

    $('input[name=delivery-type]').on('change', function () {
        var selected = $(this).val();
        var deliveryDetailsTitle = $('#deliveryDetailsTitle');
        var customerDetails = $('#customer_details');
        var partnerSelectTitle = $('#partnerSelectTitle');
        var partnerSelectDescription = $('#partnerSelectDescription');

        if (selected === 'collect-from-retailer') {
            deliveryDetailsTitle.text('BILLING DETAILS');
            customerDetails.hide();
            partnerSelectTitle.text('SELECT YOUR PICKUP LOCATION');
            partnerSelectDescription.html('Please enter your postcode and select a store for collection.<span class="requiredDD">*</span>')

        } else {
            deliveryDetailsTitle.text('DELIVERY DETAILS')
            customerDetails.show();
            partnerSelectTitle.text('YOUR LOCAL WOODPECKER PARTNERS');
            partnerSelectDescription.html('Below is a list of your local Woodpecker Partners based on your postcode<span class="requiredDD">*</span>')
        }
    })


    ///////////////////////////
    //Request Samples in Loop//
    ///////////////////////////
    $('#page').on('click', ".request-sample-in-loop", function () {
        // var id = $(this).data('id');
        var url = $(this).data('url');
        var attr = $(this).data('attribute');
        var id = $(this).data('id');
        var var_id = $(this).data('variation-id')
        var type = $(this).data('type');
        var data = {}
        if (type === 'variable') {
            data = {
                quantity: 1,
                product_id: id,
                'add-to-cart': id,
                variation_id: var_id,
                add_sample: '',
                attribute_pa_option: attr
            }
        } else {
            data = {
                quantity: 1,
                product_id: id,
                add_sample: '',
            }
        }
        $(this).text('Adding Sample')
        $(this).addClass('sample-added');
        $('.request-sample-in-loop').prop('disabled', 'disabled')
        var that = $(this);

        jQuery.post(url, data)
            .done(function (result) {
                console.log(result);
                that.text('Sample Added');
                $('.request-sample-in-loop').not('.sample-added').prop('disabled', false);
                jQuery.post('/?wc-ajax=get_cart_count_from_cart_ajax').done(function (response) {

                    // console.log(response);
                    $('.cart-customlocation .count').text(response);
                    slideUpAddedToBasketBar()
                    // if (response > 3) {
                    //     $('ul.products .request-sample').text('Max Samples Reached')
                    //     $('ul.products .request-sample').prop('disabled', 'disabled');
                    // }
                })
            })
    })

    $('body').on('click', '.variable-sample-trigger', function () {
        $(this).siblings('.variable-sample-buttons').toggleClass('active');
    })


    $('.add-to-wishlist-text').on('click', function () {
        $('.add_to_wishlist').click();
    })

    $(document.body).on('added_to_cart', function () {
        slideUpAddedToBasketBar()
    });

    function slideUpAddedToBasketBar(){
        $('.added-to-basket-bar .count').removeClass('animate')
        if($('.added-to-basket-bar').hasClass('active')){
            setTimeout(function(){
                $('.added-to-basket-bar .count').addClass('animate')
            }, 500)
        }
        $('.added-to-basket-bar').addClass('active').animate({
            bottom: 0
        }, {
            duration: 1000,
            done: function() {
                $('.added-to-basket-bar .count').addClass('animate')
            }
        });
    }


    if ($(window).width() < 992) {
        //Single product page stuff
        var tab = $('ul.tabs.wc-tabs li');
        tab.removeClass('active');
        $('.woocommerce-Tabs-panel').hide();
        tab.on('click', function () {
            $(this).toggleClass('is-active');
            $('.woocommerce-tabs').toggleClass('has-been-activated');
            var toChange = $(this).attr('aria-controls');
            if (!$(this).hasClass('is-active')) {
                $('#' + toChange).addClass('is-hidden');
            } else {
                $('.woocommerce-Tabs-panel').removeClass('is-hidden');

            }
        })

        //Footer Tab stuff

        $('.link-list h6').on('click', function () {
            $(this).toggleClass('active');
            $(this).siblings('ul').toggle();
        })

    }

    /**
     * The mobile menu panel is position: fixed, so it has to start at the
     * header's real bottom edge in the viewport. That is no longer a constant:
     * the promo bar above the header pushes it down, and the bar scrolls away
     * with the page. _header.scss reads this back as --mobile-menu-top.
     */
    function positionMobileMenu() {
        var header = document.querySelector('.site-header');
        if (!header) return;
        var bottom = Math.max(0, header.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--mobile-menu-top', bottom + 'px');
    }

    function toggleMobileMenu() {
        var opening = !$('#mega-menu-primary').hasClass('mobile-menu-active');

        $('#mega-menu-primary').toggleClass('mobile-menu-active');
        $('body').toggleClass('oy-hidden');
        $('.mobile-menu-background').toggleClass('active');

        // Measured after the classes land, not before: .oy-hidden takes the body
        // to position: fixed, which moves the header — up by the admin bar's 32px
        // when one is showing, and back to the top of the page if it was scrolled.
        // Reading it here is reading where the header actually is while the menu
        // is open. getBoundingClientRect forces layout, so this still applies
        // before the browser paints the open panel.
        if (opening) positionMobileMenu();
    }

    $('.menu-icon a').on('click', function (e) {
        e.preventDefault();
        toggleMobileMenu();
    })

    $('.mobile-menu-background').on('click', function (e) {
        e.preventDefault();
        toggleMobileMenu();
    })

    // Rotating the device with the menu open would otherwise leave it measured
    // against the old layout.
    $(window).on('resize orientationchange', function () {
        if ($('#mega-menu-primary').hasClass('mobile-menu-active')) {
            positionMobileMenu();
        }
    })

    /**
     * Header search is an icon in the reskinned header — clicking it drops the
     * existing search field down underneath the header row.
     */
    $('.search-icon a').on('click', function (e) {
        e.preventDefault();
        var $panel = $('.site-header .header-row-container .site-search');
        var isOpen = $panel.toggleClass('is-open').hasClass('is-open');

        $('.site-header').toggleClass('search-active', isOpen);
        $(this).attr('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen) {
            $panel.find('input[type="search"], input[type="text"]').first().focus();
        }
    })

    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            $('.site-header .site-search').removeClass('is-open');
            $('.site-header').removeClass('search-active');
            $('.search-icon a').attr('aria-expanded', 'false');
        }
    })

    /**
     * Change the height of the images to match the calculator
     */
    // 2026 reskin: the block that used to sit here pinned
    // .iconic-woothumbs-all-images-wrap to a hard-coded 444px. The gallery now
    // takes its height from the summary column in CSS, and the inline style was
    // only being beaten by an !important — removed so there is one thing sizing
    // the gallery rather than two.
    //
    // The .help-measuring-trigger handler went with the link itself.

    $('#wastage-trigger').on('click', function (e) {
        e.preventDefault();
        $('.wastage-modal').addClass('active');
        $('.woodpecker-modal-overlay').addClass('active')
    })

    $('#open-qty-trigger').on('click', function(e){
        e.preventDefault();
        var opts = $('#CalcOptionSelect');
        if(opts.length === 0) {
            $('.totals').slideDown();
            $('.packQuantity').trigger('focus');
        } else {
            if(opts.val() === ''){
                opts.addClass('issue');
            } else {
                opts.removeClass('issue');
                $('.totals').slideDown();
                $('.packQuantity').trigger('focus');
            }
        }
    })

    $('.modal-close').on('click', function () {
        $('.wastage-modal').removeClass('active');
        $('.woodpecker-modal-overlay').removeClass('active')

    })

    $(document).on("keydown", ".roomlength, .roomwidth, .roomarea, #shipping_postcode, #billing_postcode", function (event) {
        return event.key !== "Enter";
    });

    $('.product-remove-fake .fake-remove, .product-quantity .fake-remove').on('click', function(e){
        e.preventDefault();
        var name = $(this).data('product-name');
        var link = $(this).attr('href');
        $('.confirm-remove-modal, .confirm-remove-modal-bg').addClass('active');
        var title = $('.confirm-remove-modal h4').text();
        var replacedTitle = title.replace('{{item}}', name);
        $('.confirm-remove-modal h4').text(replacedTitle);
        $('.confirm-remove-from-cart').attr('data-url', link);
    })

    $('.close-remove-modal').on('click', function(){
        $('.confirm-remove-modal, .confirm-remove-modal-bg').removeClass('active');
        $('.confirm-remove-modal h4').text("Are you sure you want to remove {{item}} from your basket");



    })

    $('.confirm-remove-from-cart').on('click', function(){
        var url = $(this).attr('data-url')
        console.log(url);
        $(this).addClass('loading');
        $(this).prop('disabled', true);

        $.ajax({
            url: url,
            method: "GET"
        }).done(function(msg){
            var el = $('.fake-remove[href="' + url +'"]')
            el.parents('tr').remove();
            $('.confirm-remove-modal, .confirm-remove-modal-bg').removeClass('active');
            $('.confirm-remove-modal h4').text("Are you sure you want to remove {{item}} from your basket");
            $('.confirm-remove-from-cart').removeClass('loading');
            $('.confirm-remove-from-cart').prop('disabled', false);
            jQuery.post('/?wc-ajax=get_cart_count_from_cart_ajax').done(function (response) {
                $('.cart-customlocation .count').text(response);
            })
            jQuery.post('/?wc-ajax=get_cart_subtotal_from_cart_ajax').done(function (response) {
                $('.cart-subtotal td[data-title="Subtotal"]').html(response);
            })
            jQuery.post('/?wc-ajax=get_cart_total_from_cart_ajax').done(function (response) {
                $('.order-total td[data-title="Total"]').html(response);
            })

        }).fail(function(msg){
            alert(msg);
        })
    })

    $('.partner-select input').on('click', function (e) {
        e.preventDefault();
    })

    //Smooth Scroll for Anchor Links

    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('[href*="tab-"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                        ;
                    });
                }
            }
        });
})

var inputBox = document.getElementById("room_size");
if (inputBox) {
    var invalidChars = [
        "-",
        "+",
        "e",
        "E"
    ];

    inputBox.addEventListener("keydown", function (e) {
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
    });
}





/**
 * 2026 reskin — the product page's "Read More" description.
 *
 * Real copy runs to five or six lines, which is what pushed the summary column
 * past the foot of the gallery. The block is clamped and opens on demand.
 *
 * The clamp is applied here, not in the stylesheet alone, so that a reader with
 * no JS gets the whole description rather than four lines and no way to open
 * them. The button is rendered hidden server-side and only shown once we know
 * the copy actually overflows — a four-line description gets no control.
 */
(function () {
    var READ_MORE = 'Read More';
    var READ_LESS = 'Read Less';

    // Keep in step with $pdp-desc-clamp-lines in
    // assets/sass/theme/_single-product-2026.scss, which sets the collapsed
    // height. If the two disagree the button either appears with nothing to
    // reveal or is withheld from copy that is being cut.
    var PDP_CLAMP_LINES = 4;

    function setup(block) {
        var copy = block.querySelector('.product-short-description__copy');
        var toggle = block.querySelector('.product-short-description__toggle');

        if (!copy || !toggle) {
            return;
        }

        // Nothing to open. The block is not rendered at all for an empty short
        // description, so this only catches copy that is markup without words —
        // but the button must never outlive the text it belongs to.
        if (!copy.textContent.trim()) {
            toggle.remove();
            return;
        }

        // Measured while still open. A -webkit-box that is clamped does not
        // report the hidden lines as overflow — scrollHeight comes back equal to
        // clientHeight — so comparing the two after collapsing finds nothing and
        // the description silently stays open. Compare the full height against
        // the clamp instead, before it goes on.
        var lineHeight = parseFloat(window.getComputedStyle(copy).lineHeight);

        if (!lineHeight) {
            lineHeight = parseFloat(window.getComputedStyle(copy).fontSize) * 1.55;
        }

        // 2px allowance so sub-pixel line heights do not offer to open a
        // description that is already showing in full.
        if (copy.getBoundingClientRect().height <= (lineHeight * PDP_CLAMP_LINES) + 2) {
            return;
        }

        block.classList.add('is-collapsed');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.hidden = false;

        toggle.addEventListener('click', function () {
            var collapsed = block.classList.toggle('is-collapsed');
            toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
            toggle.textContent = collapsed ? READ_MORE : READ_LESS;
        });
    }

    function init() {
        var blocks = document.querySelectorAll('.product-short-description[data-readmore]');

        if (!blocks.length) {
            return;
        }

        // Larken arrives over the network, and it is wider than the fallback —
        // measuring before it lands can undercount the lines and leave a long
        // description with no way to open it.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(function () {
                Array.prototype.forEach.call(blocks, setup);
            });
            return;
        }

        Array.prototype.forEach.call(blocks, setup);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

/**
 * 2026 reskin — plank style popovers.
 *
 * The tiles under the product title illustrate the plank styles a floor comes in.
 * They select nothing: two variations can share a style (wide plank lacquered /
 * wide plank oiled), so a tile cannot stand in for the choice, which is made in
 * the calculator's dropdown. A click opens the copy held centrally on the Plank
 * Styles options page. See inc/plankStyles.php.
 */
(function () {
    var groups = document.querySelectorAll('.plank-selector[data-plank-styles]');

    if (!groups.length) {
        return;
    }

    // One at a time, across every group on the page — two cards open at once would
    // overlap, since each is positioned against its own row.
    var openTrigger = null;

    function panelFor(trigger) {
        return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function close() {
        if (!openTrigger) {
            return;
        }

        var panel = panelFor(openTrigger);

        if (panel) {
            panel.hidden = true;
        }

        openTrigger.setAttribute('aria-expanded', 'false');
        openTrigger = null;
    }

    function open(trigger) {
        var panel = panelFor(trigger);

        if (!panel) {
            return;
        }

        close();
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        openTrigger = trigger;
    }

    Array.prototype.forEach.call(groups, function (group) {
        group.addEventListener('click', function (e) {
            var trigger = e.target.closest('.plank-selector__swatch');

            if (!trigger) {
                return;
            }

            if (trigger === openTrigger) {
                close();
            } else {
                open(trigger);
            }
        });
    });

    document.addEventListener('click', function (e) {
        if (!openTrigger || e.target.closest('.plank-selector')) {
            return;
        }

        close();
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !openTrigger) {
            return;
        }

        var closing = openTrigger;
        close();
        closing.focus();
    });
})();

/**
 * 2026 reskin — the product gallery's thumbnail rail.
 *
 * WooThumbs sizes the rail itself: its viewport is the thumbnail's own height
 * times the "thumbnails to show" setting (four). The design instead pins the
 * rail to the height of the summary column — `top: 0; bottom: 0` inside a
 * clipped wrap, see theme/_single-product-2026.scss — and the two figures never
 * agree. Slick only ever knew its own, which broke the rail three ways:
 *
 * * Its viewport was 812px inside a 756px wrap, so the fourth thumbnail was cut
 *   off halfway with nothing on screen to say so.
 * * Its paging stops at `slideCount - slidesToShow`. With three and three
 *   quarter thumbnails actually on screen that left the last one permanently
 *   out of reach — click the fourth and the fifth could never be got to.
 * * Its own arrow-visibility test compares the number of photographs against
 *   the *setting*, so any product with four or fewer was read as showing all of
 *   them and both arrows were hidden. That is two thirds of the catalogue, and
 *   why the arrows looked as though they had never been added at all.
 *
 * So the rail is measured here and slick is told the truth: how many whole
 * thumbnails fit the column, and a thumbnail height that makes exactly that
 * many fill it. The count is not chosen freely — it is the nearest whole number
 * of thumbnails to the design's crop, so the shape barely moves.
 *
 * The arrows' state is taken over for the same reason. It is written as a class
 * and read with `!important`, so it no longer matters whether the plugin's own
 * inline show/hide runs before or after this.
 */
(function () {
    var $ = window.jQuery;

    if (!$) {
        return;
    }

    var WRAP = '.iconic-woothumbs-thumbnails-wrap';
    var RAIL = '.iconic-woothumbs-thumbnails';
    var IMAGES = '.iconic-woothumbs-images';
    var SLIDE = '.iconic-woothumbs-thumbnails__slide';
    var CONTROL = '.iconic-woothumbs-thumbnails__control';
    var IDLE = 'iconic-woothumbs-thumbnails__control--idle';
    var MANAGED = 'iconic-woothumbs-thumbnails-wrap--managed';

    // w/h. Mirrors $pdp-thumb-ratio in theme/_single-product-2026.scss.
    var THUMB_RATIO = 0.761;

    // Re-measuring is what triggers the event we re-measure on, so the second
    // pass has to be allowed to find nothing to do rather than be re-entered.
    var applying = false;

    // Open only for the rail's own scroll, below — see govern().
    var scrolling = false;

    function instance(el) {
        return el && el.slick && el.slick.$slides ? el.slick : null;
    }

    function rail(el) {
        return instance($(el).closest('.iconic-woothumbs-all-images-wrap').find(RAIL).get(0));
    }

    /**
     * How many whole thumbnails the visible rail should hold, and the height
     * that makes them fill it exactly.
     *
     * Null unless the rail is the clipped, pinned one this exists to correct:
     * below the desktop breakpoint it is in flow under the main image, at its
     * natural height, and WooThumbs' own figures are already right there.
     */
    function fit($wrap, $rail, slick) {
        var wrap = $wrap.get(0);
        var $slide = $rail.find(SLIDE).first();
        var height = wrap.clientHeight;
        var width = $rail.get(0).clientWidth;

        if (window.getComputedStyle(wrap).position !== 'absolute' || !$slide.length || !height || !width) {
            return null;
        }

        var gap = $slide.outerHeight(true) - $slide.outerHeight();
        var designed = width / THUMB_RATIO + gap;
        var count = Math.max(1, Math.min(Math.round((height + gap) / designed), slick.slideCount));

        // The last thumbnail's own gap falls outside the wrap, which is what
        // makes `count` of them come to the visible height on the nose.
        return {
            count: count,
            thumb: (height - (count - 1) * gap) / count
        };
    }

    function markControls($wrap, slick) {
        var last = Math.max(0, slick.slideCount - slick.options.slidesToShow);

        $wrap.find(CONTROL).each(function () {
            var forward = this.className.indexOf('--down') > -1 || this.className.indexOf('--right') > -1;

            // The inline value is the plugin's reading of the track, which is
            // the reading this whole block exists to replace.
            this.style.display = '';
            this.classList.toggle(IDLE, forward ? slick.currentSlide >= last : slick.currentSlide <= 0);
        });
    }

    /**
     * Take the rail's own scrolling off the plugin.
     *
     * WooThumbs repositions the rail on every change of the main photograph,
     * through `go_to_thumbnail()`, and its rule is to put the chosen thumbnail
     * one place down from the top — clamped against its thumbnails-to-show
     * *setting* rather than against how many are really on screen. So it moved
     * the rail on nearly every click, including clicks on thumbnails already in
     * plain view, and its clamp sent it backwards as readily as forwards.
     *
     * There is no filter over it, and the handler it sits in also pauses video,
     * loads posters and tears the zoom down, so it cannot simply be unbound.
     * Its one call into the rail is intercepted here instead. `slickPrev` and
     * `slickNext` are untouched, so the rail's own arrows still work, as does
     * dragging it — neither goes through this method.
     */
    function govern(slick) {
        if (slick.woodpeckerGoverned) {
            return;
        }

        slick.woodpeckerGoverned = true;

        var native = slick.slickGoTo;

        slick.slickGoTo = function (index, dontAnimate) {
            if (!scrolling) {
                return;
            }

            return native.call(slick, index, dontAnimate);
        };
    }

    /**
     * Bring a thumbnail into view, and only if it is not already there.
     *
     * A thumbnail on screen is left exactly where it is. Off the top the rail
     * scrolls it to the top, off the bottom to the bottom, and either way by
     * the least it can.
     */
    function reveal(slick, index) {
        var show = slick.options.slidesToShow;
        var first = slick.currentSlide;
        var target;

        if (index < first) {
            target = index;
        } else if (index > first + show - 1) {
            target = index - show + 1;
        } else {
            return;
        }

        target = Math.max(0, Math.min(target, slick.slideCount - show));

        scrolling = true;

        try {
            $(slick.$slider).slick('slickGoTo', target);
        } finally {
            scrolling = false;
        }
    }

    /**
     * The index of the photograph on show, which is the thumbnail the rail has
     * to be holding.
     */
    function showing(el) {
        var images = instance($(el).closest('.iconic-woothumbs-all-images-wrap').find(IMAGES).get(0));

        return images ? images.currentSlide : null;
    }

    function apply(el, initial) {
        var slick = instance(el);

        if (!slick || applying) {
            return;
        }

        applying = true;

        // Re-applied rather than applied once: a variation change throws the
        // instance away and builds another.
        govern(slick);

        var $rail = $(el);
        var $wrap = $rail.closest(WRAP);
        var target = $wrap.length ? fit($wrap, $rail, slick) : null;

        if (target) {
            $wrap.get(0).style.setProperty('--wf-thumb-height', target.thumb + 'px');

            if (slick.options.slidesToShow !== target.count) {
                // Refresh, so that the height just written is what slick
                // measures the track from.
                $rail.slick('slickSetOption', 'slidesToShow', target.count, true);
                slick = instance(el) || slick;
            }
        } else if ($wrap.length) {
            $wrap.get(0).style.removeProperty('--wf-thumb-height');
        }

        if ($wrap.length) {
            $wrap.addClass(MANAGED);
            markControls($wrap, slick);
        }

        // The plugin also positions the rail when the gallery is *built* with a
        // variation already chosen, through the same call intercepted above, so
        // that one is picked up here. On the build only: doing it on every
        // re-measure pulled the rail back to the photograph on show the moment
        // anyone scrolled it with an arrow.
        if (initial) {
            var index = showing(el);

            if (index !== null) {
                reveal(slick, index);
            }
        }

        applying = false;
    }

    $(function () {
        // `setPosition` is slick's own "I have re-measured", which covers the
        // breakpoint switch, the plugin's resize handler putting its setting
        // back, and a variation swapping the gallery out. Delegated, so none of
        // it depends on the rail surviving that swap.
        $(document)
            .on('init reInit setPosition afterChange', RAIL, function (event) {
                apply(this, event.type === 'init' || event.type === 'reInit');
            })

            // The rail follows the main image, so a photograph reached by any
            // means has its thumbnail on screen. Bound to the image slider
            // rather than to a thumbnail click, so the keyboard and a swipe
            // bring the rail along too.
            //
            // `beforeChange` carries the slide being moved to, and is where the
            // plugin does its own version, so the rail travels with the main
            // image rather than a fade behind it. `afterChange` is a backstop
            // for anything that reaches a slide without announcing it first —
            // revealing a thumbnail already in view does nothing.
            .on('beforeChange', IMAGES, function (event, images, from, to) {
                var slick = rail(this);

                if (slick) {
                    reveal(slick, to);
                }
            })
            .on('afterChange', IMAGES, function (event, images, index) {
                var slick = rail(this);

                if (slick) {
                    reveal(slick, index);
                }
            });

        // The rail is built once its images have loaded, so on ready there is
        // usually nothing there yet to measure.
        var el = $(RAIL).get(0);

        if (!el) {
            return;
        }

        // The column the rail is measured against is the summary's height, and
        // that settles after this runs — a web font arriving, the description
        // clamping, a variation changing the calculator. None of it goes
        // through slick, so none of it fires an event above. Re-measuring the
        // thumbnails does not change the wrap's height, which is pinned top and
        // bottom, so this cannot chase its own tail.
        if (window.ResizeObserver) {
            var wrap = $(el).closest(WRAP).get(0);

            if (wrap) {
                new window.ResizeObserver(function () {
                    apply(el);
                }).observe(wrap);
            }
        }

        var waiting = setInterval(function () {
            if (!instance(el)) {
                return;
            }

            clearInterval(waiting);
            apply(el);
        }, 100);

        setTimeout(function () {
            clearInterval(waiting);
        }, 10000);
    });
})();
